const PageLayout = ({ title, children }) => (<div className="flex flex-col gap-4 p-4 max-w-5xl mx-auto md:gap-6 md:p-6">
        {title && <h1 className="headline-m">{title}</h1>}
        {children}
    </div>);
export default PageLayout;
